<header #appHeader class="app-header">
  <a class="skip-link" href="#main-content">Siirry pääsisältöön</a>

  <div class="brand">
    <a class="brand__logo-link" [href]="rakennustietoUrl" aria-label="Rakennustieto">
      <img
        class="brand__logo"
        ngSrc="/images/rati-logo.png"
        width="371"
        height="35"
        priority
        alt="Rakennustieto"
      />
    </a>
    <!-- <a class="brand__text" routerLink="/">
      <span class="brand__name">Säädöspankki</span>
      <span class="brand__tagline">Suomen ja EU:n säädösselain</span>
    </a> -->
  </div>

  <nav class="primary-nav" aria-label="Päänavigointi">
    <a
      routerLink="/saadokset"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: false }"
      >Rakentajan säädöspankki</a
    >
    @if (authIsAdmin()) {
    <a
      routerLink="/vertailu"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: false }"
      >Vertailu</a
    >
    <a
      routerLink="/hallinta"
      routerLinkActive="is-active"
      [routerLinkActiveOptions]="{ exact: false }"
      >Hallinta</a
    >
    }
  </nav>

  <span class="header-spacer"></span>

  <!-- <section class="dataset-status" aria-label="Tietoaineistojen tila" aria-live="polite">
    @if (datasetError()) {
    <strong>Finlex-rajapinta ei ole käytettävissä</strong>
    <span>Käynnistä pysyvä taustapalvelu tai tiedostojärjestelmän varapalvelu.</span>
    } @else {
    <strong
      >Finlex: {{ availableDatasetCount() }}/{{ datasets().length }} tietoaineistoa
      käytettävissä</strong
    >
    <span>{{ sourceLabel() }} · {{ freshnessLabel() }}</span>
    }
  </section> -->

  <section class="auth-status" aria-label="Käyttäjätili">
    @switch (authState().status) { @case ('loading') {
    <span aria-live="polite">Tarkistetaan kirjautumista…</span>
    } @case ('authenticated') {
    <a class="auth-status__home" [href]="omaEtusivuUrl">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path fill="currentColor" d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8h5Z" />
      </svg>
      Oma etusivu
    </a>
    <app-user-menu />
    } @default {
    <button type="button" class="auth-status__login" [disabled]="loginBusy()" (click)="login()">
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M11 7 9.6 8.4l2.6 2.6H2v2h10.2l-2.6 2.6L11 17l5-5-5-5Zm9 12h-8v2h8a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-8v2h8v14Z"
        />
      </svg>
      Kirjaudu sisään
    </button>
    } }
  </section>
</header>

<main id="main-content" class="app-main" tabindex="-1">
  <router-outlet />
</main>

<app-site-footer />
